import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=b4bd209e&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"
import style0 from "./Permission.vue?vue&type=style&index=0&id=b4bd209e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bd209e",
  null
  
)

export default component.exports